
    import "src/shared/components/OrderInfoSlider/components/ChatUi/index.module.scss?farm_css_modules";
    
    export default {"cardStyles": `cardStyles-da0ed9cc`,"chatDiv": `chatDiv-da0ed9cc`,"messageParentDiv": `messageParentDiv-da0ed9cc`,"messagesHeading": `messagesHeading-da0ed9cc`}
    